import React, { useEffect } from 'react'
import Header from '../Component/Header'
import HomeSlider from '../Component/HomeSlider'
import ClassTabs from '../Component/ClassTabs'
import Calendar from '../Component/Calender'
import Activities from '../Component/Activities'
import Events from '../Component/Events'
import Message from '../Component/Message'
import Gallery from '../Component/Gallery'
import TopperX from '../Component/TopperX'
import TopperXII from '../Component/TopperXII'
import Birthday from '../Component/Birthday'
import Footer from '../Component/Footer'
import LazyLoad from 'react-lazyload'
import { Link } from 'react-router-dom'
import Popup from '../Component/Popup'
import OnlineRegistration from '../Component/OnlineRegistration'
import Thought from '../Component/Thought'
const Home = () => {
  useEffect(() => {
    document.title = 'Home -  St Peters convent School Faridabad Haryana';
  }, []);
  return (
    <>
      <Popup />
      <div className="OnlineR onladm">
        <span className="bounce1">
          <Link to="/AdmissionXI" target="_blank" className="parantlogo"> Admission Class XI </Link>
        </span>
      </div>
      <OnlineRegistration />
      <Header></Header>
      <HomeSlider />
      <div className="container aboutmidsec aboutmidsecnew1 padded-sec">
        <div className='button'>
          <Link to="/OurMotto">
            <LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/mission.gif" alt="SPCSH" /></LazyLoad>
            <p className='abt-txt'>MISSION vision <span>& motto</span></p>
            <p className='read_more'> READ MORE  <i class="bi bi-chevron-double-right"></i></p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/">
            <LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/studentlogin.gif" alt="SPCSH" /></LazyLoad>
            <p className='abt-txt'>Student <span>Login</span></p>
            <p className='read_more'> READ MORE  <i class="bi bi-chevron-double-right"></i></p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/Admission">
            <LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/adminfo.gif" alt="SPCSH" /></LazyLoad>
            <p className='abt-txt'>Admission <span>Information</span></p>
            <p className='read_more'>READ MORE <i class="bi bi-chevron-double-right"></i></p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/CbseDisclosure">
            <LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/cbse.gif" alt="SPCSH" /></LazyLoad>
            <p className='abt-txt'>Mandatory <span>disclosure</span></p>
            <p className='read_more'>READ MORE <i class="bi bi-chevron-double-right"></i></p>
          </Link>
        </div>
        <div className='button'>
          <Link to="/AluminiAssociation">
            <LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/alumni.gif" alt="SPCSH" /></LazyLoad>
            <p className='abt-txt'>ALUMINI
              <span> ASSOCIATION</span></p>
            <p className='read_more'>READ MORE <i class="bi bi-chevron-double-right"></i></p>
          </Link>
        </div>
      </div>
      <div class="homeabout">
        <div className="container-fluid fulwidth">
          {/* <Thought /> */}
          <div className="row">
            <div className="col-xl-5 col-lg-12">
              <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/aboutbg.png" className="img-fluid aboutimg" alt="SPCSH" />
            </div>
            <div className="col-xl-7 col-lg-12">
              <div className="maintitle">
                <p>About Us</p>
                <h1>st. Peter's convent school</h1>
              </div>
              <div className="aboutmiddec"><p>St. Peter's Convent School, Sector 88, Greater Faridabad is a recognized unaided Christian minority institution, established in <b>2013</b>. Affiliated to the Central Board of Secondary Education (CBSE), New Delhi <b>(Affiliation No. 531674, School Code 41651),</b> the school provides a nurturing environment focused on academic excellence, character formation, and the holistic growth of every student.  <br />  The school is administered by the Sisters of the Congregation of the Mother of Carmel (CMC)—a pioneering religious and charitable institution with over <b>150 </b> years of distinguished service in education. Since its founding in <b>1866</b>, the CMC has established and manages hundreds of educational institutions across India and abroad, including schools, colleges, and vocational training centers.   </p></div>
              <div className="aboutinfo">
                <div className="aboutinfobox">
                  <div className="aboutinfoboximg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/totalstudent.gif" className="img-fluid" alt="SPCSH" />
                  </div>
                  <div className="aboutinfoboxdesc">
                    <h6>1900+</h6>
                    <p>TOTAL <span>STUDENTS</span></p>
                  </div>
                </div>
                <div className="aboutinfobox">
                  <div className="aboutinfoboximg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/totalstaff.gif" className="img-fluid" alt="SPCSH" />
                  </div>
                  <div className="aboutinfoboxdesc">
                    <h6>90+</h6>
                    <p>TOTAL <span>STAFF</span></p>
                  </div>
                </div>
                <div className="aboutinfobox">
                  <div className="aboutinfoboximg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/totalclass.gif" className="img-fluid" alt="SPCSH" />
                  </div>
                  <div className="aboutinfoboxdesc">
                    <h6>65+</h6>
                    <p>TOTAL <span>CLASSROOMS</span></p>
                  </div>
                </div>
                <div className="aboutinfobox">
                  <div className="aboutinfoboximg">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/teacherstudent.gif" className="img-fluid" alt="SPCSH" />
                  </div>
                  <div className="aboutinfoboxdesc">
                    <h6>1:21</h6>
                    <p>Teacher <span>Student Ratio</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='classSection'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-12'>
              <div className="maintitle">
                <p>academics</p>
                <h1>Our curriculum</h1>
              </div>
              <ClassTabs />

            </div>

          </div>
        </div>
      </div>
      <div className='calendersec'>
        <div className="container-fluid fulwidth">
          <div className='row'>
            <div className='col-xl-6 col-lg-12'>
              <div className="maintitle">
                <p>dates and events</p>
                <h1>academic calendar</h1>
              </div>
              <Calendar />
              <Events />
            </div>
            <div className='col-xl-6 col-lg-12'>
              <div className="maintitle">
                <p>News & Achievements</p>
                <h1>recent activities & <span> announcements <a href="/News"><i class="bi bi-chevron-double-right"></i></a></span> </h1>
              </div>
              <Activities />
            </div>
          </div>
        </div>
      </div>
      <div className="messagesec">
        <div className="container fulwidth">
          <div className="row">
            <div className="col-lg-12">
              <div className="maintitle">
                <p>from the desk of</p>
                <h1>Message section</h1>
              </div>
            </div>
            <div className="col-lg-12">
              <Message />
            </div>
          </div>
        </div>
      </div>
      <div class="facilities">
        <div class="container-fluid fulwidth">
          <div class="row">
            <div className="col-lg-12">
              <div className="maintitle">
                <p>infrastructure</p>
                <h1>facilities in our <span>school</span></h1>
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-md-6">
              <div class="facilitiesbox">
                <div className="facilitiesimg">
                  <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/facilitiesbg.png" className="img-fluid" />
                  <div className="facilitiesimg1">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/facilities1.gif" className="img-fluid" />
                  </div>
                </div>
                <h3>Transport</h3><p>A safe, reliable, and convenient transportation system is essential for every school. Our school transport service ensures timely pickups and drop-offs with trained drivers, dedicated attendants, and GPS-enabled vehicles. Designed to reduce traffic congestion and support working parents, this service prioritizes student safety, efficiency, and peace of mind.</p>
                <button className='button m-auto '><Link to="/">Read More <i className="bi bi-arrow-right"></i></Link></button>
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-md-6">
              <div class="facilitiesbox">
                <div className="facilitiesimg">
                  <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/facilitiesbg.png" className="img-fluid" />
                  <div className="facilitiesimg1">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/facilities2.gif" className="img-fluid" />
                  </div>
                </div>
                <h3>sports complex</h3>
                <p>The School Sports Complex is a dynamic space dedicated to promoting physical fitness, teamwork, and holistic development among students. Equipped with modern facilities for indoor and outdoor games—such as basketball, football, volleyball, athletics, and more—it provides a platform for students to explore and excel in various sports.</p>
                <button className='button m-auto '><Link to="/">Read More <i className="bi bi-arrow-right"></i></Link></button>
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-md-6">
              <div class="facilitiesbox">
                <div className="facilitiesimg">
                  <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/facilitiesbg.png" className="img-fluid" />
                  <div className="facilitiesimg1">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/facilities3.gif" className="img-fluid" />
                  </div>
                </div>
                <h3>infirmary</h3>
                <p>The school's medical facility is fully equipped to provide immediate care and support to students in case of illness or injury during school hours. The health room includes dedicated beds for rest and observation, along with essential first-aid supplies, a qualified nurse, and regular health check-ups.</p>
                <button className='button m-auto '><Link to="/">Read More <i className="bi bi-arrow-right"></i></Link></button>
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-md-6">
              <div class="facilitiesbox">
                <div className="facilitiesimg">
                  <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/facilitiesbg.png" className="img-fluid" />
                  <div className="facilitiesimg1">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/facilities4.gif" className="img-fluid" />
                  </div>
                </div>
                <h3>elevator</h3>
                <p>The school elevator is designed to provide easy and safe accessibility across all floors of the campus. It is especially helpful for students with special needs, staff members, and visitors who may face difficulty using stairs. The elevator is spacious, regularly maintained, and complies with safety standards, ensuring smooth and secure transportation within the building.</p>
                <button className='button m-auto '><Link to="/">Read More <i className="bi bi-arrow-right"></i></Link></button>
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-md-6">
              <div class="facilitiesbox">
                <div className="facilitiesimg">
                  <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/facilitiesbg.png" className="img-fluid" />
                  <div className="facilitiesimg1">
                    <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/facilities5.gif" className="img-fluid" />
                  </div>
                </div>
                <h3>eco-friendly measures</h3>
                <p>Our school is committed to sustainability and environmental responsibility through the adoption of eco-friendly measures across the campus. These initiatives aim to educate students about green living while reducing our ecological footprint.</p>
                <button className='button m-auto '><Link to="/">Read More <i className="bi bi-arrow-right"></i></Link></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="topper_bg padded-sec">
        <div className="container-fluid section-title">
          <div className='row'>
            <div className='col-xl-8 col-lg-8'>
              <div className='row'>
                <div className='col-md-12'>
                  <div className="maintitle">
                    <LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/stars.gif" className='img-fluid m-auto d-block titleimg' /></LazyLoad>
                    <p>Our Toppers</p>
                    <h1>shining stars </h1>
                  </div>
                </div>
                { /*  <div className="col-lg-6">
            <div className='topper-block'>
              <div className='title'>
                <h4>XII Toppers</h4>
                <div className='arrrow-btn'> 
                </div>
              </div>
              <TopperXII />
            </div>
               <button className='button m-auto '><Link to="/">Read More <i className="bi bi-arrow-right"></i></Link></button>  
          </div> */}
                <div className="col-lg-12">
                  <div className='topper-block'>
                    <div className='title'>
                      <h4>X Toppers</h4>
                      <div className='arrrow-btn'>
                        {/* <Link to="/">
                  <i className="bi bi-chevron-right"></i></Link>*/}
                      </div>
                    </div>
                    <TopperX />
                  </div>
                  <button className='button m-auto '><Link to="/ToppersX">Read More <i className="bi bi-arrow-right"></i></Link></button>
                </div>


              </div>
            </div>
            <div className='col-xl-4 col-lg-4'>
              <div className="maintitle">
                <LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/birthday.gif" className='img-fluid m-auto d-block titleimg' /></LazyLoad>
                <p>Born on This Day</p>
                <h1>today’s birthday</h1>
              </div>
              <div className="col-lg-12">
                <div className='topper-block'>
                  <div className='title'>
                    <h2> </h2>
                  </div>
                  <Birthday />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="chooseus padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className='col-md-12 section-title'>
              <div className="maintitle">
                <p>Why choose us?</p>
                <h1>what sets us apart </h1>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="chooseuspart">
                <div className="chooseuspartleft">
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn1.png" className='img-fluid' />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Mindful Time</h6>
                      { /*  <p><span> - Lorem Ipsum</span></p> */}
                      <p>Mindful Time is a calm, reflective moment of meditation embedded into each school day, helping students enhances emotional balance, mental clarity, and focus. This practice prepares them to engage in the day’s learning with mindfulness and positive energy, creating a peaceful start that fosters academic and personal growth.</p>

                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn2.png" className='img-fluid' />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Book Bloom </h6>

                      <p>Book Bloom is a dedicated reading time designed to nurture a love for literature and build essential literacy skills. During this time, students engage in silent reading, library exploration, and peer discussions, helping them develop comprehension, vocabulary, and critical thinking, and fostering a lifelong passion for reading.</p>

                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn3.png" className='img-fluid' />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Right Reach </h6>

                      <p>Through the Right Reach initiative, students are paired with their peers to offer academic and emotional support. This program promotes inclusivity, empathy, and collaboration, helping students who may be struggling to feel more connected and confident in their learning journey while encouraging leadership and peer responsibility.</p>

                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn4.png" className='img-fluid' />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Lead Point </h6>
                      <p>  The Lead Point program empowers students to actively participate in school governance through elected roles in the Student Council. By being involved in decision-making processes and leadership responsibilities, students gain valuable skills in democracy, teamwork, and leadership, preparing them for roles of responsibility in the future.</p>

                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn5.png" className='img-fluid' />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Lingua Lift </h6>
                      <p> Lingua Lift enhances communication skills by immersing students in structured language learning, where they engage in three days of English communication and two days in the regional language each week. This exposure helps students become versatile communicators, improving their fluency, confidence, and cultural understanding, essential for global citizenship.</p>

                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn6.png" className='img-fluid' />
                    </div>
                    <div className="chooseuspartrgtbox">
                      <h6>Skill Nest </h6>
                      <p>  In Skill Nest, students engage in hands-on, project-based learning that integrates life skills such as critical thinking, problem-solving, emotional intelligence, and teamwork. These activities are designed to empower students to confidently handle real-world challenges, building practical skills that go beyond academic knowledge.</p>

                    </div>
                  </div>
                </div>
                <div className="chooseuspartcenter">
                  <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusimg.png" className='img-fluid chooseuspartcenterimg' />
                  <div className="chooseuspartbox">
                    <button className='button m-auto '><Link to="/WhatSetsUsApart">Read More <i className="bi bi-arrow-right"></i></Link></button>

                  </div>
                </div>
                <div className="chooseuspartright">
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6>Heart Basket</h6>

                      <p> Heart Basket is a unique initiative that encourages students to bring an extra food packet each month to donate to the underprivileged. Through this simple but impactful act of sharing, students learn empathy, social responsibility, and the value of contributing to their community, fostering a spirit of kindness and generosity.</p>

                    </div>
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn7.png" className='img-fluid' />
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6>Soul Stroke</h6>

                      <p> Soul Stroke is an initiative where students use the medium of art to reflect on moral, social, and personal values. Through creative expression, they explore ethical themes, engage with societal issues, and build emotional resilience, making art a powerful tool for self-awareness and value-based learning.</p>

                    </div>
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn8.png" className='img-fluid' />
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6>Eco Echo </h6>

                      <p> Eco Echo fosters a commitment to environmental sustainability. Students participate in activities like tree planting, recycling, and waste reduction, helping to create a greener, more sustainable school campus. This initiative instills a sense of ecological responsibility, encouraging students to become active caretakers of the planet.</p>

                    </div>
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn9.png" className='img-fluid' />
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6>Inspire Times</h6>

                      <p> Inspire Times is a program where each month is dedicated to a specific theme, incorporating events that align with key learning objectives and desired outcomes. These events, such as encourage students to explore new concepts, engage in hands-on activities, and deepen their knowledge across important events of the month to celebrate diverse aspects of knowledge, values, and culture through focused events .Thematic learning enhances retention and makes learning more meaningful and contextual.</p>

                    </div>
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn10.png" className='img-fluid' />
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6>Satsewa</h6>

                      <p> The Satsewa program is designed to encourage social outreach and community service. Through this initiative, students participate in charitable activities such as visiting elderly homes, donating food, participating in e-learning and teaching and supporting local causes. Satsewa instills in students a deep sense of social responsibility, empathy, and active citizenship, reinforcing the importance of giving back to society.</p>

                    </div>
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn11.png" className='img-fluid' />
                    </div>
                  </div>
                  <div className="chooseuspartbox">
                    <div className="chooseuspartrgtbox">
                      <h6>Peter’s Merit Scholarship </h6>

                      <p> The Peter’s Merit Scholarship is a prestigious recognition for academic excellence. Students who achieve 97% or above in their annual academic performance are awarded a 100% tuition fee waiver. This scholarship not only rewards outstanding academic achievement but also motivates students to strive for excellence in their educational journey.</p>

                    </div>
                    <div className="chooseuspartlftbox">
                      <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/chooseusicn12.png" className='img-fluid' />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="homegallery padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className='col-md-12 section-title'>
              <div className='title'>
                <h2>Activities in Images</h2>
              </div>
            </div>
            <div className="col-lg-12">
              <Gallery />
              {/* <button className='button'><Link to="/Gallery">Read More</Link></button> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Home
